export const PriceErrorCode = ['B22', 'B23', 'B24', 'B25', 'B21', 'B55', 'B144']

export const isPriceError = (errorCode) => PriceErrorCode.includes(errorCode)
